import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { LabelText } from "./ReworkJobModal.styles";
import { useAuth } from "../../../utility/useAuth";
import { getJobOperations } from "../../../services/ApiService";

interface IReworkJobModal {
  open: boolean;
  onReworkJob: (jobNumber: string, operation: string) => void;
  onClose: () => void;
  user: string;
  jobNumber: string;
  isRejected: boolean;
}

export const ReworkJobModal: FC<IReworkJobModal> = ({
  open,
  onReworkJob,
  onClose,
  user,
  jobNumber,
  isRejected,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const auth = useAuth();

  useEffect(() => {
    getJobOperations(
      auth,
      jobNumber,
      isRejected ? "rejected" : "completed"
    ).then((result) => {
      const jobOperations = result.map(({ resourceNo }) => resourceNo);
      setOperations(jobOperations);
      if (jobOperations && jobOperations.length > 0) {
        setOperation(jobOperations[jobOperations?.length - 1]);
      }
      
    });
  }, [jobNumber, isRejected]);

  const [operation, setOperation] = useState("");
  const [operations, setOperations] = useState<string[]>([]);

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onReworkJob(jobNumber, operation);
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  function onOperationChange(args: any) {
    if (args) {
      setOperation(args.value);
    }
  }

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <>
              {user}, are you sure that you want to rework job {jobNumber}{" "}
              operation?
            </>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>Operation</LabelText>
            </Col>
            <Col>
              <DropDownListComponent
                id="ddlelement"
                dataSource={operations}
                value={operation}
                placeholder="Select an operation"
                onChange={onOperationChange}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
